// extracted by mini-css-extract-plugin
export var csatScore = "_j7-5";
export var header = "_j7-1";
export var panelWrapper = "_j7-2";
export var postPreview = "_j7-3";
export var rightContent = "_j7-0";
export var wrappingText = "_j7-4";